import { createContext, useState } from "react";
import { establishementKey, contactsStorageKey } from "../consts";
import { EstablishmentCategory, ContactProfil } from "../types";

type InitData = {
    [establishementKey]: {
        establishmentTypes: EstablishmentCategory[];
        establishmentGroups: EstablishmentCategory[];
    };
    [contactsStorageKey]: {
        profils: ContactProfil[];
    };
    initDataContext: (v: any) => void;
};

export const InitDataContext = createContext<InitData>({
    [establishementKey]: {
        establishmentTypes: [],
        establishmentGroups: [],
    },
    [contactsStorageKey]: {
        profils: [],
    },
    initDataContext: (value: any) => null,
});

export const InitDataContextProvider = (props: any) => {
    const [dataInit, setInitData] = useState({
        [establishementKey]: {
            establishmentTypes: [],
            establishmentGroups: [],
        },
        [contactsStorageKey]: {
            profils: [],
        },
    });

    const initDataContext = (value: any) => {
        setInitData(value);
    };

    return (
        <InitDataContext.Provider
            value={{
                ...dataInit,
                initDataContext,
            }}
        >
            {props.children}
        </InitDataContext.Provider>
    );
};
